import * as React from 'react'
import { Button, Form } from 'react-bootstrap'
import { Pencil, X } from 'react-bootstrap-icons'


export const GeneralAccountObj : GeneralAccountT = {
    id: null,
    account_type: '',
    name: '',
    account_number_start: 0,
    account_number_end: 0
}

export interface GeneralAccountT {
    id : number | null
    account_type : string
    name : string
    account_number_start : number
    account_number_end : number
}

interface GeneralAccountInterface {
    account : GeneralAccountT
    deleteGeneralAccount(id : number) : void
    updateAccount (id : number, key : string, value : string) : void
 }

const GeneralAccount : React.FunctionComponent<GeneralAccountInterface> = ({account, deleteGeneralAccount, updateAccount}) : JSX.Element => {

    return (
        <Form>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 150px'}}>
                <Form.Group>
                    <Form.Label>Type</Form.Label>
                    <Form.Control className="input-material" value={account.account_type} readOnly />
                </Form.Group>
                <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                        className="input-material"
                        onChange={(ev => {
                            updateAccount(account.id, 'name', ev.target.value)
                            alert(ev.target.value)
                        })}
                        value={account.name} />
                </Form.Group>
                <Form.Group>
                    <Form.Label>Start</Form.Label>
                    <Form.Control
                        className="input-material"
                        onChange={(ev => {
                            updateAccount(account.id, 'account_number_start', ev.target.value)
                            alert(ev.target.value)
                        })}
                        value={account.account_number_start} />
                </Form.Group>
                <Form.Group>
                    <Form.Label>End</Form.Label>
                    <Form.Control
                        className="input-material"
                        onChange={(ev => {
                            updateAccount(account.id, 'account_number_end', ev.target.value)
                        })}
                        value={account.account_number_end} />
                </Form.Group>
                <Form.Group>
                    <Pencil color='blue' size={35} />
                    <X
                        color='red'
                        size={35}
                        onClick={()=> {
                            deleteGeneralAccount(account.id)
                        }} />
                </Form.Group>
            </div>
        </Form>
    )
}

export default GeneralAccount